import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').config(loginRouterConfig);

    /** @ngInject */
    function loginRouterConfig($stateProvider) {
        $stateProvider
            .state('login', {
                url: '/logowanie',
                template: '<im-login></im-login>',
            })
            .state('logout', {
                url: '/wylogowanie',
                controller: 'LogoutController',
                controllerAs: 'LogoutCtrl',
            })
            .state('passwordReminder', {
                url: '/przypomnienie-hasla',
                template: '<im-password-reminder></im-password-reminder>',
            })
            .state('setNewPassword', {
                url: '/auth/password/reset/confirm/:uid/:token/',
                template: require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/partials/login/setNewPassword.html'),
                controller: 'SetNewPasswordController',
                controllerAs: 'SetNewPasswordCtrl',
            });
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/partials/login/routes/login.route.ts